import axios from "axios";

// In modalità self-hosted Docker, REACT_APP_BACKEND_URL è vuoto e le API
// passano dal reverse proxy Nginx sullo stesso host (path-only).
// In modalità Emergent/dev, REACT_APP_BACKEND_URL contiene la URL completa.
const envBackendUrl = process.env.REACT_APP_BACKEND_URL || "";
const isEmergentPreviewHost =
  typeof window !== "undefined" &&
  (window.location.hostname.includes("preview.emergentagent.com") ||
    window.location.hostname.includes("emergentagent.com") ||
    window.location.hostname.includes("preview"));

// In preview prefer same-origin to avoid hardcoded/stale backend domains.
export const BACKEND_URL = isEmergentPreviewHost ? "" : envBackendUrl;
export const API = `${BACKEND_URL}/api`;

// Configurazione API client con interceptors per PIN auth
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Inject PIN header on every request
api.interceptors.request.use((config) => {
  const pin = localStorage.getItem("app_pin");
  if (pin) config.headers["X-App-Pin"] = pin;
  return config;
});

// Redirect to /login on 401
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("app_pin");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const isAuthed = () => !!localStorage.getItem("app_pin");
export const logout = () => { localStorage.removeItem("app_pin"); window.location.href = "/login"; };

export const TIPI_INTERVENTO = [
  "Cambio gomme",
  "Montaggio",
  "Smontaggio",
  "Deposito",
  "Riparazione",
  "Equilibratura",
  "Convergenza",
  "Altro",
];

export const STAGIONI = ["Estivo", "Invernale", "4 Stagioni"];
export const MAGAZZINI = ["Vasto", "Cupello"];
export const SCAFFALI = ["A", "B", "C", "D", "E", "F"];
export const SCAFFALI_VASTO = ["A", "B", "C"];
export const SCAFFALI_CUPELLO = ["A", "B", "C", "D", "E", "F"];
export const getScaffaliForMagazzino = (m) => (m === "Cupello" ? SCAFFALI_CUPELLO : SCAFFALI_VASTO);
export const STATI = ["Attivo", "Ritirato", "Smaltito"];

export const SETTORI = Array.from({ length: 121 }, (_, i) => i + 1);

export const MARCHI_PNEUMATICO = [
  "Pirelli",
  "Michelin",
  "Bridgestone",
  "Continental",
  "Goodyear",
  "Dunlop",
  "Hankook",
  "Yokohama",
  "Nokian",
  "Falken",
  "Toyo",
  "Kumho",
  "BFGoodrich",
  "General",
  "Altro",
];
